import { useAdobeTracking } from './adobe/useAdobeTracking.js'
import { useDataLayerMeta } from './useDataLayerMeta.js'

type Props = {
  meta: {
    isLoggedIn: boolean
    topLevelDomain: string
  }
  providers: {
    isAdobeEnabled?: boolean
  }
}

/**
 * This hook will be use to general provide information from the interal datalayer to providers like Adobe.
 * Don not forget to implement the initDataLayer() in the root of your application.
 *
 * Note: For Adobe tracking, import and use `useAdobeTracking` from './adobe/useAdobeTracking.js' directly
 * in your application instead of relying on this generic provider hook.
 */
export const useDataLayerForProvider = ({
  meta: { isLoggedIn, topLevelDomain },
  providers: { isAdobeEnabled = false },
}: Props): void => {
  useDataLayerMeta({ isLoggedIn, topLevelDomain })
  useAdobeTracking(isAdobeEnabled)
}
